import {GridColDef} from '@mui/x-data-grid-pro';

export enum ErrorGridType {
  ProductionErrors = 'productionErrors',
  PlaceHolderErrors = 'placeholderErrors',
}

export const transformApiDataToRows = (
  data: any[] | undefined,
  gridType: ErrorGridType,
  pageSize: number
) => {
  const realRows =
    data?.map((item, index) => ({
      id: item.generateErrorId || index + 1,
      documentId: item.docID || '',
      hiddenDocumentId: item.documentId,
      error: item.error || '',
      subjectFileName: item.fileName || '',
      docFileType: item.docType || '',
      sourceParentDocId: item.parentID || '',
      replaceSeedPdf: item.isReplacePDF === '1' ? 'Yes' : 'No',
      ...(gridType === ErrorGridType.PlaceHolderErrors && {
        nativeExported: item.nativeExported ? 'Yes' : 'No',
      }),
    })) || [];

  const emptyRowsCount = pageSize - (realRows.length % pageSize || pageSize);

  const emptyRows = Array.from({length: emptyRowsCount}, (_, i) => ({
    id: `empty-${i}`,
    isEmpty: true,
    documentId: '',
    error: '',
    subjectFileName: '',
    docFileType: '',
    sourceParentDocId: '',
    replaceSeedPdf: '',
    ...(gridType === ErrorGridType.PlaceHolderErrors && {
      nativeExported: '',
    }),
  }));

  return [...realRows, ...emptyRows];
};

export const productionErrorColumns: GridColDef[] = [
  {
    field: 'documentId',
    headerName: 'Document ID',
    flex: 0.8,
  },
  {
    field: 'error',
    headerName: 'Error',
    flex: 1.3,
  },
  {
    field: 'subjectFileName',
    headerName: 'Subject/File Name',
    flex: 1,
  },
  {
    field: 'docFileType',
    headerName: 'Doc File Type',
    flex: 0.8,
  },
  {
    field: 'sourceParentDocId',
    headerName: 'Source Parent Doc ID',
    flex: 1.2,
  },
  {
    field: 'replaceSeedPdf',
    headerName: 'Replace Seed PDF',
    flex: 1,
  },
];

export const placeholderErrorColumns: GridColDef[] = [
  ...productionErrorColumns,
  {
    field: 'nativeExported',
    headerName: 'Native Exported',
    flex: 1,
  },
];
